import React from "react"

import { Checkbox } from "@tenforce/product-fields"

import { updateField } from "../../slice"
import { useAppDispatch } from "../../../../hooks"
import HTMLAndInternalLinkParser from "../common/HTMLAndInternalLinkParser"
import { Labels } from "../../../../util/Translations"
import { ICheckboxField } from "../../index"

export interface Props {
    field: ICheckboxField
}

export const CheckboxField = ({ field }: Props): JSX.Element => {
    const dispatch = useAppDispatch()

    const {
        position: _position,
        odataType: _odataType,
        value,
        ...fieldProps
    } = field

    const { ClickHereToEdit, RequiredFieldErrorMessage } = Labels

    return (
        <Checkbox
            {...fieldProps}
            description={
                <HTMLAndInternalLinkParser
                    content={(field?.description as string) ?? ""}
                />
            }
            value={value}
            placeholder={ClickHereToEdit}
            mandatoryErrorText={RequiredFieldErrorMessage}
            onSave={(newValue: boolean): void => {
                if (newValue === value) {
                    return
                }
                dispatch(
                    updateField({
                        field,
                        newValue,
                    }),
                )
            }}
        />
    )
}

export default CheckboxField
